import { Dispatch } from "react";
import cropTypeService from "../service/cropTypeService";
import { ICropType } from "../types/cropType";
import { ActionType, actionTypes } from "../types/state";

export const ALL_CROP_TYPES_QUERY = {
  page: 1,
  pageSize: 1000,
  searchTerm: "",
};

export async function loadCropTypes(
  dispatch?: Dispatch<ActionType>
): Promise<ICropType[]> {
  const cropTypes = (await cropTypeService.get(ALL_CROP_TYPES_QUERY)) || [];
  dispatch?.({ type: actionTypes.setCropTypes, value: cropTypes });
  return cropTypes;
}
